import React, { useState } from "react";
import styled from "styled-components";
import { Tooltip, Typography } from "antd";

interface ILegendLabelProps {
  index: number;
  label: string;
}
const colors = ["rgba(255, 150, 45,1)", "rgb(139, 165, 230)", "rgb(211, 27, 27)", "rgb(24, 195, 81)"];

const LegendLabel: React.FC<ILegendLabelProps> = ({ index, label }) => {
  const { Paragraph } = Typography;
  const [ellipsisState, setEllipsistate] = useState(true);

  return (
    <Tooltip zIndex={99999} placement="top" title={ellipsisState ? label : undefined}>
      <div key={index} className="d-flex flex-row align-items-center legend-label">
        <ColoredLabel color={colors[index]} height={"11px"} borderRadius={"8px"} />
        <Paragraph className="legend-label-text" data-id="graph-legend-label" ellipsis={{ rows: 2, onEllipsis: setEllipsistate }}>
          {label}
        </Paragraph>
      </div>
    </Tooltip>
  );
};

export default LegendLabel;

interface IColoredLabelProps {
  color?: string;
  height: string;
  borderRadius: string;
}
const ColoredLabel = styled("div")<IColoredLabelProps>`
  display: inline-block;
  min-width: 32px;
  background: ${(props: any) => props.color};
  height: ${(props: any) => props.height};
  border-radius: ${(props: any) => props.borderRadius};
  margin-right: 5px;
`;
